// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { PERSON_ROLE_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/accountPersonRoleType';
import {
  T_PERSON_TRANSACTION_MY_CLIENT_SCHEMA,
  T_PERSON_TRANSACTION_SCHEMA,
} from 'app/modules/goAML/schemas/tPersonTransactionSchema';

export const SIGNATORY_IS_PRIMARY: FormFieldSchema<string> = {
  label: 'Is primary?',
  name: 'is_primary',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: [
      {
        value: '0',
        text: 'No',
      },
      {
        value: '1',
        text: 'Yes',
      },
    ],
  },
  default: '1',
};

export const SIGNATORY_ROLE: FormFieldSchema<string> = {
  label: 'Role',
  name: 'role',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: PERSON_ROLE_TYPE_OPTIONS,
  },
  required: true,
  validate: required('Role is required.'),
};

export const SIGNATORY_RAW_INPUTS = [SIGNATORY_IS_PRIMARY, SIGNATORY_ROLE];

export const SIGNATORY_SCHEMA = [
  ...SIGNATORY_RAW_INPUTS,
  ...T_PERSON_TRANSACTION_SCHEMA.map((config) => ({
    ...config,
    name: `t_person.${config.name}`,
  })),
];

export const SIGNATORY_MY_CLIENT_SCHEMA = [
  ...SIGNATORY_RAW_INPUTS,
  ...T_PERSON_TRANSACTION_MY_CLIENT_SCHEMA.map((config) => ({
    ...config,
    name: `t_person.${config.name}`,
  })),
];
